import React from "react";
import PageBanner from "./pageBanner/PageBanner";
import Content from "carbon-react/lib/components/content";
import { findRolesWithEntitlement } from "../../../config/agentEntitlementConfig";
import { getAgentRoleDisplayValue } from "../../../constants/model";

const CenteredContent = (props) => {
  return <Content align="center">{props.children}</Content>;
};

const UnauthorisedBanner = () => {
  const getAgentRoleDisplayNamesWithInviteAgentEntitlement = () => {
    try {
      const roles = findRolesWithEntitlement((entitlement) => {
        return entitlement.tabs.showManageAgents === true;
      });
      return roles?.map((role) => {
        return getAgentRoleDisplayValue(role);
      });
    } catch (error) {}
    return null;
  };

  const inviteAgentRoles = getAgentRoleDisplayNamesWithInviteAgentEntitlement();

  const bannerMsg = `You don't appear to be authorised to use this application. If you
  require access, please request this from your manager${
    inviteAgentRoles && inviteAgentRoles.length > 0
      ? ` or another agent with the role '${inviteAgentRoles.join("/")}'`
      : ""
  }.`;

  return (
    <PageBanner id="error-banner" title="Authorisation Required">
      <CenteredContent>{bannerMsg}</CenteredContent>
    </PageBanner>
  );
};

export default UnauthorisedBanner;
